import React from "react";
import { Button } from "./Button";
import { ReactComponent as QrIcon } from "../icons/qr.svg";
import { ReactComponent as Copy } from "../icons/Clip.svg";
import { ReactComponent as DownloadIcon } from "../icons/download.svg";
import styles from "./QrDownloadInput.scss";
import { useClipboard } from "use-clipboard-copy";
import { defineMessage, useIntl } from "react-intl";
import PropTypes from "prop-types";

const copiedQRMessage = defineMessage({
  id: "invite-popover.qr-code-copy",
  defaultMessage: "The QR Code has been copied"
});

const downloadedQRMessage = defineMessage({
  id: "invite-popover.qr-code-download",
  defaultMessage: "The QR Code has been downloaded correctly"
});

export function QrDownloadInput({ label, qrCode }) {
  const intl = useIntl();

  const clipboard = useClipboard({
    copiedTimeout: 600
  });

  const copyLabel = intl.formatMessage(copiedQRMessage);
  const downloadLabel = intl.formatMessage(downloadedQRMessage);

  const download = () => {
    if (!qrCode) return;

    const link = document.createElement("a");
    link.href = qrCode;
    link.download = "qr.png";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.dispatchEvent(new CustomEvent("toast-message", { detail: downloadLabel }));
  };

  const copyQrCode = () => {
    if (!qrCode) return;
    clipboard.copy(qrCode);
    window.dispatchEvent(new CustomEvent("toast-message", { detail: copyLabel }));
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.input}>
          <QrIcon className={styles.qrIconInput} />
          {label}
        </div>
        <div className={styles.afterInput}>
          <Button onClick={copyQrCode} className={styles.button}>
            <Copy className={styles.qrIcon}></Copy>
          </Button>
          <Button className={styles.button} onClick={download}>
            <DownloadIcon className={styles.qrIcon}></DownloadIcon>
          </Button>
        </div>
      </div>
    </>
  );
}

QrDownloadInput.propTypes = {
  label: PropTypes.node,
  qrCode: PropTypes.string
};
